import { Description } from './description';

export class Scene{
  scene:String;
  description:Array<Description> = new Array<Description>();
}
